import Vue from "vue";
import Vuetify from "vuetify/lib";
//import i18n from '@/i18n'
import "@/sass/overrides.sass";

Vue.use(Vuetify);

const theme = {
  primary: "#607D8B",
  secondary: "#5d86b4",
  accent: "#90A4AE",
  info: "#17a2b8",
  success: "#28a745",
  warning: "#e0ca61",
  danger: "#dd5b59",
  sand: "#dcc4be",
  platinum: "#899aad",
};

export default new Vuetify({
  // lang: {
  //   t: (key, ...params) => i18n.t(key, params),
  // },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
